
  import React from 'react';;

  export const frontMatter = {};

  export default class ReactMarkdown extends React.PureComponent {
    render() {
      const props = this.props;

      return <div>
  <h2>flomとはなんですか</h2>
  <p>flomは、ロボットのモーションをキーフレームで表現するためのライブラリ・ファイルフォーマットです。GPLv3で公開されています。(<a href="https://github.com/MonoMotion/flom">MonoMotion/flom</a>)</p>
  <h2>何ができるの</h2>
  <p>モーションデータに対して、</p>
  <ul>
    <li>任意の時間地点での姿勢を取得できる(フレーム補完)</li>
    <li>任意のFPSでフレームをイテレート</li>
    <li>
      <p>ファイルにインポート/エクスポートする</p>
      <ul>
        <li>JSONにもなります</li>
        <li>protobufでファイルフォーマットは記述されています</li>
      </ul>
    </li>
    <li>キーフレーム編集(挿入/削除)</li>
    <li>
      <p>"エフェクタ"設定のサポート</p>
      <ul>
        <li>"エフェクタ"はリンクの理想姿勢を表現するのに使うことができます</li>
        <li><a href="/technology/effectors">エフェクタについてはこちらをご覧ください</a></li>
      </ul>
    </li>
  </ul>
  <h3>言語は</h3>
  <p>C++です Pythonバインディングもあります(<a href="https://github.com/MonoMotion/flom-py">MonoMotion/flom-py</a>)</p>
  <h2>なぜこれが必要なの</h2>
  <p>今まで「ロボットのモーション」を表現するには、JSONやCSVで各関節の角度の変化を時系列で記述していく方法がありました。しかし、そういった汎用的はデータ構造で記述されたモーションデータに対してフレーム補完をする方法が一般的になく、ソフトウェアを新しく作成するたびに補完処理などを書く必要がありました。</p>
  <p>MonoMotionフレームワークでは、「ロボットのモーション」を生成し、加工し、実行します。「ロボットのモーション」を複数のソフトウェアが扱うため、共通したコードベースがあればモーションを扱う上でのトラブルが減ると思い、新しくライブラリを作成するに至りました。</p>
  <h2>どう使われているの</h2>
  <p>MonoMotionフレームワーク内で、モーションをファイルとして保存するのに使われています。また、任意の時間地点での姿勢を取得できる特徴を生かして学習ソフトウェアの実装を簡単にする目的でも使われています。</p>
  <h2>ちなみに</h2>
  <p>MonoMotionのなかで一番コミット数が多い(今の所)。</p>
</div>
;
    }
  }